import { create } from 'zustand';
import { defaultCalenderBoundry } from '../components/Sankey/constants';

interface IUserInfo {
  api_key?: string;
  customer_enabled?: boolean;
  customer_id?: number;
  customer_name?: string;
  hidden?: boolean;
  instant_filter_enabled?: number;
  is_selected?: boolean;
  primary?: boolean;
  profile_id?: number;
  role?: string;
  timezone?: number;
  tzName?: string;
  username?: string;
  can_use_preview?: boolean;
  is_tlb2?: boolean;
  data_access_months?: number;
  activation_creator_enabled?: boolean;
  eco_activation_flow?: boolean;
  is_new_workflow?: boolean;
  eco_new_data_model?: boolean;
  app_spi?: boolean;
  data_source_type?: number;
  mobile_visual_activation?: boolean;
  workbench_account?: number;
  is_workbench_account?: boolean;
  show_workbench_toggle?: boolean;
  session_replay?: boolean;
  enable_pattern_flow?: boolean;
  enable_livelens_find_by_ip?: boolean;
}

interface IInitialInfoStore {
  userInfo: IUserInfo;
  setUserInfo: (userInfo: IUserInfo) => void;
  predefinedMappedEvents: any[];
  setPredefinedMappedEvents: (predefinedMappedEvents: any[]) => void;
  metadata: any[];
  setMetadata: (metadata: any[]) => void;
  empCalenderBoundry: any;
  setEmpCalenderBoundry: (empCalenderBoundry: any) => void;
  trendsCalenderBoundry: any;
  setTrendsCalenderBoundry: (trendsCalenderBoundry: any) => void;
  workbenchMode: boolean;
  setWorkbenchMode: (workbenchMode: boolean) => void;
}

export const useInitialInfoStore = create<IInitialInfoStore>((set) => ({
  userInfo: {},
  setUserInfo: (userInfo) => set(() => ({ userInfo })),
  predefinedMappedEvents: [],
  setPredefinedMappedEvents: (predefinedMappedEvents) => set(() => ({ predefinedMappedEvents })),
  metadata: [],
  setMetadata: (metadata) => set(() => ({ metadata })),
  empCalenderBoundry: defaultCalenderBoundry,
  setEmpCalenderBoundry: (empCalenderBoundry) => set(() => ({ empCalenderBoundry })),
  trendsCalenderBoundry: defaultCalenderBoundry,
  setTrendsCalenderBoundry: (trendsCalenderBoundry) => set(() => ({ trendsCalenderBoundry })),
  workbenchMode: false,
  setWorkbenchMode: (workbenchMode) => set(() => ({ workbenchMode })),
}));
